// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1wDz2188J42fbh0VfXnD7J"};